import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { HelmetProvider } from 'react-helmet-async';

import { Loader } from '../base/components/Loader';
import { SnackbarManager } from '../base/components/SnackBar';
import { useAppDispatch, useAppSelector } from '../base/hooks';
import { Vacancy } from './units/vacancy/pages';
import { Loading } from '../base/enums';
import { employerAppActions } from './redux/slices/employerAppSlice';
import { ResponsesPage } from './units/responses/pages';
import { ResponsesRoutes } from './units/responses/routes';

export const EmployerApp = () => {
    const dispatch = useAppDispatch();
    const { loading } = useAppSelector((state) => state.app);

    useEffect(() => {
        dispatch(employerAppActions.init());
    }, []);

    return (
        <HelmetProvider>
            <SnackbarProvider maxSnack={10}>
                <div className='employer-app'>
                    <Routes>
                        <Route path='/vacancy/*' element={<Vacancy />} />
                        <Route path={`${ResponsesRoutes.Index}/*`} element={<ResponsesPage />} />
                    </Routes>
                    <Loader showLoader={loading === Loading.App} />
                    <SnackbarManager />
                </div>
            </SnackbarProvider>
        </HelmetProvider>
    );
};
